export class ListMaintenanceRunsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListMaintenanceRunsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortMaintenanceRunBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMaintenanceRunsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
